import React from "react";
import { IIcon } from "./Icon.types";

const AlternativeSearchIcon: React.FC<IIcon> = ({
  width = "20",
  height = "21",
  viewBox = "0 0 20 21",
  onClick,
  className,
}: IIcon): JSX.Element => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      onClick={onClick}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="10.8366"
        cy="9.66667"
        r="6.66667"
        stroke="#292929"
        fill="#ffffff"
        strokeWidth="1.5"
      />
      <path
        d="M2.08008 18.4175L5.83008 14.6675"
        stroke="#292929"
        strokeWidth="1.5"
      />
    </svg>
  );
};

export default AlternativeSearchIcon;
